// src/i18n/routing.ts
import { defineRouting } from 'next-intl/routing'
import { createNavigation } from 'next-intl/navigation'

export type Locale = 'en' | 'es'

// UI / mails solo tienen es|en. defaultLanguage del bar puede ser un idioma
// de carta (fr/ca/de/eu): colapsa a en. Un solo sitio para no divergir entre
// flujos cliente/bar (issue #54 B7).
export const toUiLocale = (lang: string | null | undefined): Locale =>
  lang === 'es' ? 'es' : 'en'

export const routing = defineRouting({
  locales: ['en', 'es'] as const, // 'as const' para inferir literales
  defaultLocale: 'es'
})

// Wrappers para los APIs de navegación de Next.js
export const { Link, redirect, usePathname, useRouter } = createNavigation(routing)
